export * from './insurance-company-my-suffix.service';
export * from './insurance-company-my-suffix-update.component';
export * from './insurance-company-my-suffix-delete-dialog.component';
export * from './insurance-company-my-suffix-access-dialog.component';
export * from './insurance-company-my-suffix-detail.component';
export * from './insurance-company-my-suffix.component';
export * from './insurance-company-my-suffix.route';
